module.exports = __webpack_public_path__ + "img/bgd2.73e43eb4.png";